import PhoneIcon from '@mui/icons-material/Phone';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function FixeIcon(props: FixMe) {
  return <PhoneIcon {...props} />;
}

export default FixeIcon;
